import { useEffect, useState } from 'react'
import ReactDataGrid from '@inovua/reactdatagrid-community'
import '@inovua/reactdatagrid-community/index.css'

export default function OrdersDataGrid(props) {
  const [dataSource, setDataSource] = useState(props.orders);
  const [lineItems] = useState(props.lineItems);

  useEffect(() => {
    setDataSource(props.orders);
  }, [props.orders]);

  const calculateCreditValue = () => {
    return lineItems.reduce((acc, item) => acc + (item.unit_price * item.quantity_to_credit), 0);
  }

  const gridStyle = { minHeight: 100 };

  const columns = [
    { name: 'id', header: 'ID', defaultFlex: 1, defaultVisible: false, editable: false },
    { name: 'delivery_date', defaultFlex: 1, header: 'Delivery Date', editable: false },
    { name: 'order_number', defaultFlex: 1, header: 'Order Number', editable: false },
    { name: 'credit_note_number', defaultFlex: 1, header: 'Credit Note Number', editable: false },
    { name: 'customer_name', defaultFlex: 1, header: 'Customer Name', editable: false },
    { name: 'order_value', defaultFlex: 1, header: 'Order Value', editable: false, render: ({ value })=> '$' + value },
    {
      name: 'credit_value',
      defaultFlex: 1,
      header: 'Credit Value',
      render: ({ data }) => {
        const creditValue = calculateCreditValue();
        return `$${creditValue.toFixed(2)}`;
      }
    }
  ];

  return (
    <ReactDataGrid
      idProperty="id"
      style={gridStyle}
      editable={false}
      columns={columns}
      dataSource={dataSource}
    />
  );
}
